<template>
  <div class="main">
    <GoBack :name="`奖品详情`" :type="2" :path="`/mobile/exchange`"></GoBack>

    <!-- //阴影 -->
    <img class="shadow" src="@/assets/mobile/image/common/shadow.png" />

    <div class="content">
      <div class="content-box">
        <div class="left">
          <img
            class="exchange-img"
            :src="options.thumbImageUrl"
            @error="handleError"
          />
          <div class="name-box">
            <div class="name">{{ name }}</div>
            <div class="tip">
              已有{{ options.convertTimes }}人兑换 剩余{{ options.stock }}件
            </div>
          </div>
        </div>
        <div class="right">
          <span>{{ options.marketPoints }}</span
          >金币
        </div>
      </div>

      <div class="red-tip" v-if="options.categoryId === 2">
        注意：请确保您的微信号不是小号、不常用的号、微信账号必须要实名认证，否则将无法收到微信红包
      </div>

      <div class="red-tip" v-if="options.categoryId === 1">
        2019年12 月1日起，支付宝兑换不再享受优惠。
        （支付宝订单每周五统一审核发放）
      </div>
      <div class="red-tip">注意:所有兑换物品，兑完即止。</div>
      <div class="bule-tip">详细兑换规则请点击查看</div>
      <div :class="`btn ${flag ? 'btn-active' : ''}`" @click="exchange">
        立即兑换
      </div>
    </div>

    <MobileTips
      v-if="isTips"
      @close="close"
      @changeAccepted="changeCashoutDialogVisible"
    ></MobileTips>

    <van-dialog
      v-model="dialogVisible"
      title="提示"
      show-cancel-button
      @confirm="setOrder"
      @close="flag = false"
      allow-html
      confirm-button-text="我已确认兑换账号，立即兑换"
    >
      <div class="dialog-herder">
        <div class="title">请确认您的支付宝账号和姓名:</div>
        <div class="tips" v-if="alipay">
          支付宝账号:{{ alipay | phoneFrom }}
        </div>
        <div class="tips" v-else>支付宝账号:未填写</div>
        <div class="tips">姓名:{{ name ? name : "未填写" }}</div>
      </div>

      <div class="dialog-footer" @click="goUrl">点击前往更新支付宝</div>
    </van-dialog>

    <MobileExchangeMethod
      v-if="isMobileExchangeMethod"
      @close="isMobileExchangeMethod = false"
      :url="url"
      :name="options.name"
    ></MobileExchangeMethod>
    <ManualReview
      v-if="isManualReview"
      @submit="submit"
      :isMobule="true"
    ></ManualReview>
  </div>
</template>
<script>
import GoBack from "@/components/goBack.vue";
import { getGiftsItem, getAlipay, getAccount, setOrder } from "@/api/mobile";
import MobileTips from "@/components/mobileTips";
import MobileExchangeMethod from "@/components/mobileExchangeMethod";
import ManualReview from "@/components/manualReview";
import { Dialog } from "vant";
export default {
  filters: {
    phoneFrom(phone) {
      return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  data() {
    return {
      isTips: false,
      dialogVisible: false,
      img: null,
      options: {
        id: null,
        name: null,
        displayPoints: null,
        marketPoints: null,
        thumbImageUrl: null,
        convertTimes: null,
        stock: null,
        status: null,
        statusDesc: null,
        categoryId: null,
        categoryName: null,
        describe: null,
      },
      userInfo: {},
      alipay: null,
      name: null,

      url: "111",
      isMobileExchangeMethod: false,
      isManualReview: false,
      flag: false,
    };
  },
  components: { GoBack, MobileTips, MobileExchangeMethod, ManualReview },
  methods: {
    goUrl() {
      this.$router.push("/mobile/updateSettings?type=2");
    },
    handleError(e) {
      console.log("触发");
      e.target.src = process.env.VUE_APP_SERVER + "/images/gift/default.png";
      e.target.onerror = null; // 防止闪图/死循环
    },
    async getAlipay() {
      await getAlipay().then((res) => {
        if (res.code === 200) {
          this.alipay = res.data.alipay;
          this.name = res.data.name;
        }
      });
    },
    handleClose() {
      this.flag = false;
      this.dialogVisible = false;
    },

    exchange() {
      if (this.flag) {
        return;
      }
      this.flag = true;
      if (this.userInfo.cashoutDialogVisible && this.options.categoryId === 2) {
        this.isTips = true;
        return;
      }

      if (!this.options.stock) {
        this.$toast("此奖品库存不足啦，请耐心等待管理员补货哦！");
        return;
      }

      //微信红包
      if (this.options.categoryId === 2) {
        setOrder({
          id: this.options.id,
        }).then((res) => {
          this.flag = false;
          if (res.code === 200) {
            if (this.userInfo.credit >= 100) {
              this.url = res.data.thumbImageUrl;
              this.isMobileExchangeMethod = true;
            } else {
              this.isManualReview = true;
            }
          }
        });
        return;
      } else if (this.options.categoryId === 1) {
        // 支付宝
        this.dialogVisible = true;
      } else {
        this.setOrder();
      }
    },
    close() {
      this.isTips = false;
    },

    changeCashoutDialogVisible() {
      this.userInfo.cashoutDialogVisible = false;
      this.flag = true;
      this.exchange();
    },
    setOrder() {
      setOrder({
        id: this.options.id,
      }).then((res) => {
        this.flag = true;
        if (res.code === 200) {
          this.$toast("兑换成功");
          this.handleClose();
        } else if (res.msg === "您的账户余额不足") {
          Dialog.confirm({
            title: "提示",
            message: "账号余额不足，点我赚金币",
            confirmButtonText: "立即前往",
          })
            .then(() => {
              this.$router.push("/mobile/task");
            })
            .catch(() => {
              this.handleClose();
            });
        }
      });
    },

    submit() {
      this.isManualReview = false;
      this.$router.push("/module/redemptionHistory");
    },
  },
  async created() {
    console.log(111, this.$route.query);
    if (this.$route.query && this.$route.query.id) {
      getGiftsItem({ id: this.$route.query.id }).then((res) => {
        if (res.code === 200) {
          this.options = res.data;
        }
      });
    }
    await this.getAlipay();

    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  .shadow {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 0;
  }
  .content {
    position: relative;
    width: calc(100% - 30px);
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 0;
    .content-box {
      width: 100%;
      height: 117px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        .exchange-img {
          width: 54px;
          height: 54px;
          margin-left: 20px;
        }
        .name-box {
          display: flex;
          flex-direction: column;
          margin-left: 15px;
          justify-content: space-between;
          .name {
            font-size: 16px;
            color: #232323;
          }
          .tip {
            font-size: 12px;
            color: #999999;
          }
        }
      }
      .right {
        color: #ff3636;
        margin-right: 15px;
        font-size: 14px;
        display: flex;
        align-items: center;
        span {
          font-size: 20px;
          font-weight: bolder;
          margin-right: 2px;
        }
      }
    }
    .red-tip {
      color: #e30000;
      font-size: 14px;
      margin-top: 20px;
    }
    .bule-tip {
      color: #398cff;
      font-size: 14px;
      margin-top: 37px;
    }
    .btn {
      width: calc(100% - 76px);
      height: 42px;
      background: linear-gradient(138deg, #bb95ff 0%, #8846ff 100%);
      border-radius: 25px 25px 25px 25px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 74px;
      text-align: center;
      line-height: 42px;
      font-size: 18px;
      color: #fff;
    }
    .btn-active {
      opacity: 0.7;
    }
  }
}
.dialog-herder {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 20px;

  .title {
    margin-top: 20px;
    color: #474f66;
    font-size: 14px;
  }
  .tips {
    color: #474f66;
    font-size: 14px;
    margin-top: 5px;
  }
}
.dialog-footer {
  color: #8948ff;
  font-size: 14px;
  font-weight: bolder;
  margin: 20px;
  text-decoration: underline;
  cursor: pointer;
}
</style>